import React, { useState, useEffect,useContext } from 'react';
import DynamicIcon from '../dynamicicon';
import JisButton from './jisButton';
import * as Constants from '../../constants';
import * as Services from '../../services';
import { ShareContext } from '../../context/ShareContext';
import JisCheckbox from './jisCheckbox';
import BackLoader from '../backloader';

function JisUser({onSave, defaultUser, source}) {
     const {  activePage, token, profile, setIsExpired,frequentData} = useContext(ShareContext);
    const [user, setUser]=useState(defaultUser);
     const [roles, setRoles]= useState([]);
    const [err, setErr] =useState('');
    const [courts, setCourts] = useState([]);
    const [judgeTypes,setJudgeTypes]=useState([]);
    const [loading, setLoading] = useState(false);
    const [states, setStates] =useState([]);
    const [Lga, setLga] = useState([]);
    const [cities, setCities] = useState([]);
     const [isPass, setIsPass]=useState(true);
     const [selectedCatIds, setSelectedCatIds] =useState(new Set());

    const gender=[
        {label:'Male',value:'M'},
        {label:'Female', value:'F'}
    ]

const [caseCats, setCaseCats] = useState([]);


     useEffect(() => {
            
           onLoadRole();
           onLoadCaseCategory();

          }, []);
     const onLoadCaseCategory=async()=>{
              try {
                   setLoading(true);
                     const resp = await fetch(`${Constants.apiUrl}/setup/case-setting/case-categories`, { 
                       method: 'GET',
                       headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`,
                       },
                     });
                     
                     const data = await resp.json();
                      setLoading(false);
                     if(data.code==0){
                        setCaseCats(data.list);
                     }else if(data.code==-10){
                        setIsExpired(true)
                     }
                   
                    
                   } catch (error) {
                     setLoading(false);
                     console.error(error);
                     
                   }
        }       
 useEffect(() => {
  
     setUser(defaultUser);
        if(defaultUser.categoryIds?.length>0){
            setSelectedCatIds(new Set(defaultUser.categoryIds));
        }
   
         }, [defaultUser])

    useEffect(() => {
        
        if(user.isJudge && user.divisionId!=null){
        //load the court in the division
        onGetCourts();
        }
        
    }, [user.divisionId,user.isJudge])  
 
    
const onUserSave=async(e) =>{
   e.preventDefault();
   setErr('')
         setLoading(true)
         try {
           const isNew= user.id==0?true:false;
           const catids=Array.from(selectedCatIds);
            console.log(catids)
          // return;
           var _user={...user,categoryIds:catids};
           const url=user.id==0?`${Constants.apiUrl}/profile/newprofile`:`${Constants.apiUrl}/profile/update-profile/${user.id}`;
           const resp = await fetch(url, {
             method: 'POST',
             body:JSON.stringify(_user) ,
             headers: {
               'Content-Type': 'application/json, text/plain',
               Authorization: `Bearer ${token}`,
             },
           });
           
           const data = await resp.json();
           setLoading(false);
           if(data.code==0){
                onSave({id:data.id,isNew});
           }
           else if(data.code==-10){
                 setIsExpired(true);
             }else{
               setErr(data.status);
             }
        //   setFlow({pos:6,code:"congrat"})
           
           
         } catch (error) {
           setLoading(false);
           console.error(error);
           
          // onMove();
         }
 }
 const onUserChange = (e) => {
    setUser({...user, [e.target.name]: e.target.value})
}
 const onLoadRole= async()=>{
     //for account registration
     try {
       setLoading(true);
         const resp = await fetch(`${Constants.apiUrl}/profile/roles`, { 
           method: 'GET',
           headers: {
             'Content-Type': 'application/json',
             'Authorization': `Bearer ${token}`,
           },
         });
         
         const data = await resp.json();
         setLoading(false);
        setRoles(data);
        
       } catch (error) {
         setLoading(false);
         console.error(error);
         
       }
 }

 const onGetCourts= async()=>{
             //for account registration
             try {
               setLoading(true);
                 const resp = await fetch(`${Constants.apiUrl}/profile/getcourts/${user.divisionId}`, { 
                   method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                 const data = await resp.json();
                 setLoading(false);
                setCourts(data.courts);
                setJudgeTypes(data.types) ;
               } catch (error) {
                 setLoading(false);
                 console.error(error);   
               }
         }
  
   useEffect(() => {
   
               async function fetchData() {
    const c=await Services.onGetStates();
                 //get latest 20 records from db in addition   
                 setStates(c);
               }
               fetchData();
                
                }, [])
    useEffect(() => {
        async function fetchData() {
            if(user.state){
                const c=await Services.onGetLgs(user.state);
                setLga(c);
            } 
    }
    fetchData();
        
    }, [user.state])
              
    useEffect(() => {
    async function fetchData() {
            if(user.lga){
        const c=await Services.onGetCities(user.lga);
        setCities(c);
        }      

    }
    fetchData();
        
        
        
    }, [user.lga]) 

    const onJudgeCategoryCheck=(check, catid)=>{
        //if this user have an Id, initiate the server removal/addition, but if id=0, it will be added
        var _sc= new Set(selectedCatIds);
        if(check==true){
            if(!_sc.has(catid)){
                _sc.add(catid);
            }

        }else{
            if(_sc.has(catid)){
                _sc.delete(catid);
            }
        }
        setSelectedCatIds(new Set(_sc));
    }

  return <div className='panel'>
                    <div className='title'>User</div>
                    <div className='panel-body'>
                       <form onSubmit={onUserSave}>
                <div  style={{flex:1}}>

                <div style={{flex:1}}>
                  <div style={{display:'flex'}}>

                    <div className="select-group">
                          <label>
                              Role  
                          </label>
                          <select name="roleId" value={user.roleId} required  onChange={onUserChange} >
                              <option value="">Select </option>
                              {roles.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.name}
                              </option>
                              ))}
                          </select>
                      </div>
                     <div className="select-group">
                          <label>
                              Division  
                          </label>
                          <select name="divisionId" value={user.divisionId}  onChange={onUserChange} >
                              <option value="">Select </option>
                              {frequentData.divisions?.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                  {opt.title}
                              </option>
                              ))}
                          </select>
                      </div>
                  </div>
                          {user.isOrg ?
                          <div  className="input-group">
                                    <label> Organization Name</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="person_3" />
                                        <input placeholder='Organization Name' required={true} name="firstName" value={user.firstName} onChange={onUserChange}   />
                                    </div>
                                </div>
                          
                          :
                        <div>

                                <div className="select-group">
                                    <label> Title <span className="required">*</span></label>
                                    <select name="suffix" value={user.suffix} onChange={onUserChange} required>
                                        <option value="">Select Title</option>
                                        <option  value="Mr">Mr</option>
                                        <option value="Mrs">Mrs</option>
                                        <option value="Miss">Miss</option>
                                        <option value="Dr">Dr</option>
                                        <option value="Dr(Mrs)">Dr(Mrs)</option>
                                        <option value="Chief">Chief</option>
                                        <option value="Chief(Mrs)">Chief(Mrs)</option>
                                        <option value="Engr">Engr</option>
                                        <option value="Engr(Mrs)">Engr(Mrs)</option>
                                        <option value="Alhaji">Alhaji</option>
                                        <option value="Alhaja">Alhaja</option>
                                        <option value="Rev">Rev</option>
                                        <option value="Pastor">Pastor</option>
                                        <option value="Admiral">Admiral</option>
                                        <option value="General">General</option>
                                        <option value="Air Comm.">Air Comm.</option>
                                        <option value="Captain">Captain</option>
                                        <option value="Lt. Col">Lt. Col</option>
                                        <option value="Rev(Mrs)">Rev(Mrs)</option>
                                        <option value="Bishop">Bishop</option>
                                        <option value="Arch Bishop">Arch Bishop</option>
                                        <option value="Primate">Primate</option>
                                        <option value="Architect">Architect</option>
                                    </select>
                                </div> 
        <div>
                            <div  className="input-group">
                                    <label>Surname/Last name <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="person_3" />
                                      <input  name="lastName" required={true} value={user.lastName} onChange={onUserChange} placeholder='surname/lastname'  />
                                    </div>
                                </div>
                                
                            </div>
                            <div style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> First Name <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="person_3" />
                                    <input label="" placeholder='Firstname' required={true} name="firstName" value={user.firstName} onChange={onUserChange}   />
                                    </div>
                                </div>

                                <div  className="input-group">
                                    <label> Middle Name</label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="person_3" />
                                <input label="" placeholder='Middle Name'  name="middleName" value={user.middleName} onChange={onUserChange}  />
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                          } 

                                <div  className="input-group">
                                    <label>Address <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="add_home" />
                                        <input placeholder='address1' name="address1" required={true} value={user.address1} onChange={onUserChange}  />
                                    </div>
                                </div>
                                
                          
                            <div style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> Date of Birth <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="calender_month" />
                                      <input placeholder='Date of Birth' type="date" required name="dateOfBirth" value={user.dateOfBirth} onChange={onUserChange} 
                                />
                                    </div>

                                </div>
                                
                              
                            </div>

                        {!user.isOrg && <div style={{display:'flex'}}>
                                <div className="select-group">
                                    <label>
                                        Gender  <span className="required">*</span>
                                    </label>
                                    <select name="sex" value={user.sex} required={true} onChange={onUserChange} >
                                        <option value="">Select gender</option>
                                        {gender.map((opt) => (
                                        <option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </option>
                                        ))}
                                    </select>
                                    </div>

                                    <div className="select-group">
                                    <label> Marital Status</label>
                          
                                    <select  name="maritalStatus" value={user.maritalStatus} onChange={onUserChange} required={true}>
                                        <option value="">Select marital Status</option>
                                        <option value="M">Married</option>
                                        <option value="S">Single</option>
                                        <option value="W">Widow/Widower</option>
                                        <option value="D">Divorced</option>
                                    </select>
                                    </div>
                                

                                
                            </div>}    

                            <div  style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> Primary Email <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="email" />
                                      <input  name="primaryEmail" type="email" required value={user.primaryEmail} onChange={onUserChange} placeholder='Email'  />
                                    </div>

                                </div>
                                <div  className="input-group">
                                    <label> Primary Phone <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="phone_in_talk" />
                                      <input placeholder='primaryphone' type="tel" name="primaryContactNumber" required={true} value={user.primaryContactNumber}  onChange={onUserChange}  /> 
                                    </div>
                                </div>
                            </div>

                            <div style={{display:'flex'}}>
                                <div className="select-group">
                                    <label> State <span className="required">*</span></label>
                                    <select name="state" required={true} value={user.state} onChange={onUserChange}>
                                        <option value="">Select State</option>
                                        {states.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </option>
                                        ))}
                                    </select>
                                    </div>
                                <div className="select-group">
                                    <label> L.G.A <span className="required">*</span></label>
                                    <select  name="lga" value={user.lga} required={true} onChange={onUserChange}>
                                        <option value="">Select LG</option>
                                        {Lga.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </option>
                                        ))}
                                    </select>
                                    </div>
                              <div className="select-group">
                                    <label> City <span className="required">*</span></label>
                                    <select  name="city" value={user.city} required={true} onChange={onUserChange}>
                                        <option value="">City</option>
                                        {cities.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </option>
                                        ))}
                                    </select>
                                    </div>
                            </div> 
                         {source!='judge' && <div style={{display:'flex'}}>
                              <JisCheckbox label="Check if This Account is Legal Counsel" value={user.isLegalCounsel} onChange={(e)=>setUser({...user,isLegalCounsel:e})}/>
                              <JisCheckbox label="Check if This Account is Government Account" value={user.isMinistryOfJustice} onChange={(e)=>setUser({...user,isMinistryOfJustice:e})}/>
                            </div>}   
                          {user.isLegalCounsel && <div>
                            <div  className="input-group">
                                    <label> Bar Number<span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="phone_in_talk" />
                                      <input placeholder='Bar number' name="barNumber" required={true} value={user.barNumber}  onChange={onUserChange}  /> 
                                    </div>
                                </div>
                                <note>Legal counsel is required to provide Call to bar number</note>
                            </div>}  
                </div>
                <div style={{display:'flex'}}>
                   {source!='judge' &&  <JisCheckbox label="Check if This Account is a Judge" value={user.isJudge} onChange={(e)=>setUser({...user,isJudge:e})}/>} 
                    {user.isJudge && <><div className="select-group">
                                    <label> Court <span className="required">*</span></label>
                                    <select  name="courtId" value={user.courtId} required={true} onChange={onUserChange}>
                                        <option value="">Select Court</option>
                                        {courts.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.name}
                                        </option>
                                        ))}
                                    </select>
                                    </div>
                                    <div className="select-group">
                                        <label>
                                            Judge Type  <span className="required">*</span>
                                        </label>
                                        <select name="judgeTypeId" value={user.judgeTypeId} required={true} onChange={onUserChange} >
                                            <option value="">Select Judge Type </option>
                                            {judgeTypes?.map((opt) => (
                                            <option key={opt.id} value={opt.id}>
                                                {opt.title}
                                            </option>
                                            ))}
                                        </select>
                                    </div>
                       </> }  
                </div>
              {user.isJudge && <div style={{display:'flex'}}>
                <div style={{width:'100%'}}><h3>Select the Associated Case Category for the Judge</h3></div>
                    {caseCats?.map((opt) => (
                                           <div style={{flex:1, minWidth:'40%'}}>
                                            <JisCheckbox label={opt.categoryTitle} value={selectedCatIds.has(opt.id)} onChange={(e)=>onJudgeCategoryCheck(e,opt.id)}/>
                                           </div> 
                                            ))}
                </div>}  
  

                <div>
                  <h2>Access Information</h2>
                        <div style={{display:'flex', flexDirection:'row'}}>
                            <div style={{flex:1}}>
                            <div>
                                <div  className="input-group">
                                    <label> Username <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="person_3" />
                                    <input  placeholder='username'name="userName" value={user.userName} onChange={onUserChange} required disabled={user.id>0} />  
                                    </div>
                                </div>
                                
                            </div>
                            <div style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label>Password <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="lock" />
                                        <input placeholder='password' type={`${isPass?'password':'text'}`} name="password" value={user.password} onChange={onUserChange} required={user.id==0?true:false} />   
                                        <DynamicIcon iname={`${isPass?'visibility':'visibility_off'}`} onClick={()=> setIsPass(!isPass)} /> 
                                    </div>
                                </div>
                                <div  className="input-group">
                                    <label> Confirm Password <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="lock" />
                                      <input placeholder='confirmpassword 'name="confirmpassword" type={`${isPass?'password':'text'}`} value={user.confirmpassword} onChange={onUserChange} required={user.id==0?true:false}  />    
                                    </div>
                                </div>
                                
                            </div>
                            </div>
                    
                    </div>
                </div>
                
                
              </div>
              {err!="" && <div className='error'>{err}</div>}
                <div>
                  <JisButton type="submit"> Save</JisButton>
                </div>
              </form> 
                    </div>
                    <BackLoader open={loading} />
                    </div>   ;
}

export default JisUser;